<script>
  import chatServico from './servico';
  import UsuarioConversas from './componentes/UsuarioConversas.vue'
  import Mensagens from './componentes/Mensagens.vue'
  import Canais from './componentes/Canais.vue'
  import ModalChatGrupo from './componentes/ModalChatGrupo.vue';

  export default {
    props: {},
    components: { UsuarioConversas, Mensagens, Canais, ModalChatGrupo },
    data() {
      return {
        idUsuarioOrigem: this.$storage.usuario().id,
        nomeUsuarioOrigem: this.$storage.usuario().nome,
        chanelSelecionado: 0,
        idUsuarioDestino:0,

        quantidadeMensagensNovas: 0,       
        mensagensCarregadas: false,
        novaConversa: false,
        configuracao: this.$storage.configuracao(),
        searchCanal: '',
        searchUsuarioMensagens: '',
        mensagemEnviar: '',
        modalChatGrupo: false,

        imgUsuario: "/img/chat/perfilIndividual.png",
        imgGrupo: "/img/chat/perfilGrupo.png",
        lblMensagemTitulo: '',

        dadosCached: {
          mensagemUsuarios: [],
          usuarios: [],
        },
        dados: {
          mensagemUsuarios: [],
          mensagens: [],
          usuarios: [],
        },
      }
    },
    methods: {
      setarScrollMensagem() {
        var objDiv = document.getElementById("pnlMensagem");

        if (objDiv == undefined)
          return

        if (objDiv == null)
          return

        objDiv.scrollTop = objDiv.scrollHeight;
      },
      acessarCanais() {
        this.novaConversa = !this.novaConversa
        this.carregaCanais()
      },
      enviarMensagem() {
        if (this.mensagemEnviar == "")
          return

        const mensagem = {
          "idChatChannel": this.chanelSelecionado,
          "mensagem": this.mensagemEnviar,
          "usuario": this.nomeUsuarioOrigem,
          "idUsuarioOrigem": this.idUsuarioOrigem,
          "idUsuarioDestino": this.idUsuarioDestino,
        }

        this.mensagemEnviar = ''

        chatServico.enviarMensagem(mensagem)
          .then(res => {
            this.chanelSelecionado = res
            this.carregaMensagens()
            this.carregaMensagemUsuario()
          });
      },
      carregaMensagens(carregarMensagemUsuario = true) {
        return chatServico.carregaMensagens(this.idUsuarioOrigem, this.chanelSelecionado)
          .then(res => {
            this.dados.mensagens = res
            this.mensagensCarregadas = true

            if (carregarMensagemUsuario)
              this.carregaMensagemUsuario()
          });
      },
      carregaMensagemUsuario() {
        return chatServico.carregaMensagemUsuario(this.idUsuarioOrigem)
          .then(res => {
            this.dadosCached.mensagemUsuarios = res
            this.dados.mensagemUsuarios = res

            this.verificaMensagensNovas()
            this.aplicaSelecaoMensagem()
            this.filtrarUsuariosMensagens()
            this.setarScrollMensagem()
          });
      },
      carregaCanais() {
        return chatServico.carregaCanais(this.idUsuarioOrigem)
          .then(res => {
            this.dadosCached.usuarios = res
            this.dados.usuarios = res

            this.filtrarCanais()
          });
      },
      verificaMensagensNovas() {
        const quantidadeMensagensNovas = this.dados.mensagemUsuarios.map(msg => msg.mensagensNaoLidas).reduce(
                                            (quantidade, soma) =>  soma + quantidade,0
        )

        if (quantidadeMensagensNovas > this.quantidadeMensagensNovas) {
          this.quantidadeMensagensNovas = quantidadeMensagensNovas
          this.playSoundNotificacao()
        }          
      },
      playSoundNotificacao() {
        var sound = document.querySelector('audio')
        sound.volume = 0.3
        sound.muted = false
        sound.play()
      },
      filtrarCanais() {

        if (this.searchCanal == "") {
          this.dados.usuarios = [...this.dadosCached.usuarios]
          return
        }

        this.dados.usuarios = this.dadosCached.usuarios
          .filter(msg => msg.nomeUsuario.toLowerCase().includes(this.searchCanal))
      },
      filtrarUsuariosMensagens() {

        if (this.searchUsuarioMensagens == "") {
          this.dados.mensagemUsuarios = [...this.dadosCached.mensagemUsuarios]
          return
        }

        this.dados.mensagemUsuarios = this.dadosCached.mensagemUsuarios
          .filter(msg => msg.titulo.toLowerCase().includes(this.searchUsuarioMensagens))
      },
      iniciarChatCanal(canal) {
        this.chanelSelecionado = canal.idCanal
        this.lblMensagemTitulo = canal.nomeUsuario
        this.idUsuarioDestino = canal.idUsuarioDestino,
        this.aplicaSelecaoMensagem()
        this.carregaMensagens()
        this.novaConversa = false
      },
      selecionarChanel(canal) {
        if (canal == undefined)
          return

        this.chanelSelecionado = canal.id
        this.lblMensagemTitulo = canal.titulo
        this.aplicaSelecaoMensagem()
        this.carregaMensagens()
      },
      aplicaSelecaoMensagem() {
        this.dados.mensagemUsuarios.map(msg => msg.selecionado = (msg.id == this.chanelSelecionado))
      },
      carregarMensagensCanalSelecionado() {
        const canalSelecionado = this.dados.mensagemUsuarios.filter(msg => msg.id == this.chanelSelecionado)[0]

        if (canalSelecionado)
          this.selecionarChanel(canalSelecionado)
      },
      mostrarModalChatGrupo() {
        this.modalChatGrupo = true;
      },
      modalModalChatGrupoFechado() {
        this.animated = false;
        this.modalChatGrupo = false;
        this.carregaMensagemUsuario();
      },
    },
    computed: {
      imgMensagemTituloUsuario() {
        return this.dados.mensagens.length > 0 ?
                          this.dados.mensagens[0].grupo > 1 ? this.imgGrupo : this.imgUsuario :
                          this.imgUsuario
      },
      lblMensagemTituloNomeUsuario() {
        return this.lblMensagemTitulo
      }
    },
    mounted() {
      this.carregaMensagemUsuario()

      setInterval(() => {
        this.carregaMensagemUsuario()
        this.carregarMensagensCanalSelecionado()
      }, 30000)
    }
  }
</script>

<template>
  <div class="box-chat">
    <modal-chat-grupo :mostrar="modalChatGrupo"
                      :idUsuarioOrigem="idUsuarioOrigem"
                      :nomeUsuarioOrigem="nomeUsuarioOrigem"
                      @fechado="modalModalChatGrupoFechado">
    </modal-chat-grupo>

    <div class="audioHidden">
      <audio controls muted autoplay class="audioHidden">
        <source src="sounds/chatBip.mp3" type="audio/mpeg">
      </audio>
    </div>

    <div class="pnlUsuarios" v-if="novaConversa">
      
      <div class="pnlUsuarioPerfil">
        <img src="/img/chat/imgConversaBack.png" class="imgCanalVoltar" @click="novaConversa = !novaConversa" />
        <div></div>
        <img src="/img/chat/imgGrupo.png" class="imgUsuarioAdd" @click="mostrarModalChatGrupo" />
      </div>

      <div class="pnlUsuarioBusca">
        <div class="pnlUsuarioBuscaSearch">
          <form action="" class="search-form">
            <input v-model="searchCanal" type="search" class="search-input" name="searchCanal" id="searchCanal" v-on:keyup="filtrarCanais" placeholder="Buscar usuário">
            <button type="submit" class="search-button" @click.prevent="filtrarCanais"><i class="fa fa-search"></i></button>
          </form>
        </div>
      </div>

      <div class="pnlMensagensUsuarios">
        <div v-for="(usuario, index) in dados.usuarios">
          <Canais name-="Canais"
                  ref="Canais"
                  :canal.sync="usuario"
                  @iniciarChatCanal="iniciarChatCanal($event)"
                  :key="index">
          </Canais>
        </div>
      </div>
    </div>
    <div class="pnlUsuarios" v-else>
      <div class="pnlUsuarioPerfil">
        <img :src="imgUsuario" class="imgUsuarioPerfilUsuario" />
        <div class="lblUsuarioNome">{{ nomeUsuarioOrigem }}</div>
        <img src="/img/chat/imgUsuarioAdd.png" class="imgUsuarioAdd" @click="acessarCanais" />
      </div>

      <div class="pnlUsuarioBusca">
        <div class="pnlUsuarioBuscaSearch">
          <form action="" class="search-form">
            <input v-model="searchUsuarioMensagens" type="search" class="search-input" name="searchUsuarioMensagem" id="searchUsuarioMensagem" v-on:keyup="filtrarUsuariosMensagens" placeholder="Buscar conversas com usuário/grupo">
            <button type="submit" class="search-button" @click.prevent="filtrarUsuariosMensagens"><i class="fa fa-search"></i></button>
          </form>
        </div>
      </div>

      <div class="pnlMensagensUsuarios">
        <div v-for="(mensagemUsuario, index) in dados.mensagemUsuarios">
          <usuario-conversas name-="UsuarioConversas"
                             ref="UsuarioConversas"
                             :item.sync="mensagemUsuario"
                             @selecionarChanel="selecionarChanel($event)"
                             :key="index">
          </usuario-conversas>
        </div>
      </div>
    </div>
    <div class="pnlMensagemPrincipal">
      <div class="pnlMensagemTitulo" v-if="mensagensCarregadas">
        <img :src="imgMensagemTituloUsuario" class="imgMensagemTituloUsuario" />
        <p class="lblMensagemTituloNomeUsuario">{{ lblMensagemTituloNomeUsuario }}</p>
      </div>
      <div class="pnlMensagem" v-if="mensagensCarregadas" id="pnlMensagem">
        <div v-for="(mensagem, index) in dados.mensagens">
          <mensagens name-="mensagens"
                     ref="mensagens"
                     :mensagem.sync="mensagem"
                     :index.sync="index"
                     :key="index">
          </mensagens>
        </div>
        <div style="margin-top:10px;"></div>
      </div>
      <div class="pnlMensagemEnvio" v-if="mensagensCarregadas">
        <div class="pnlUsuarioMensagemSend">
          <form action="" class="send-form">
            <input v-model="mensagemEnviar" type="search" class="send-input" name="send" id="send" placeholder="Escrever mensagem..." @click="enviarMensagem">
            <button type="submit" class="send-button" @click.prevent="enviarMensagem"><i class="fa fa-send"></i></button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .box-chat {
    width: 100%;
    height: 100%;
    display: flex;
    
  }

  .pnlUsuarios {
    flex-direction: column;
    display: flex;
    background-color: white;
    width: 330px;
    border-right: .1rem solid #13141f40;
  }

  .pnlUsuarioPerfil {
    display: grid;
    align-items: center;
    justify-content: left;
    background-color: rgb(240, 242, 245);
    width: 100%;
    padding-bottom: 9px;
    padding-top: 10px;
    border-bottom: .04rem solid #13141f40;
    grid-template-columns: 60px 224px 46px;
  }

  .imgUsuarioPerfilUsuario {
    margin-left: 10px;
    height: 40px;
    width: 40px;
  }

  .lblUsuarioNome {
    width: 222px;
    font-size: 17px;
    font-weight: bold;
    font-family: sans-serif;
    color: gray;
  }

  .imgUsuarioAdd {
    margin-left: 7px;
    height: 32px;
    width: 32px;
    cursor: pointer;
  }

  .imgCanalVoltar {
    margin-left: 10px;
    height: 40px;
    width: 40px;
    cursor: pointer;
  }

  .pnlMensagemTitulo {
    display: flex;
    align-items: center;
    justify-content: left;
    background-color: rgb(240, 242, 245);
    width: 100%;
    height: 60px;
    border-bottom: .04rem solid #13141f40;
    min-width: 400px;
  }

  .pnlMensagem {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }

  .imgMensagemTituloUsuario {
    margin-left: 23px;
    height: 40px;
    width: 40px;
  }

  .lblMensagemTituloNomeUsuario {
    margin-bottom: 0px;
    margin-left: 23px;
    font-size: 17px;
    font-weight: bold;
    font-family: sans-serif;
    color: gray;
  }

  .pnlUsuarioBusca {
    background-color: white;
    padding: 5px;
    height: 46px;
    border-bottom: 0.05rem solid #13141f17;
  }

  .pnlUsuarioMensagemSend {
    position: relative;
    margin: 0 auto;
    height: 100%;
  }

  .search-form {
    background-color: #13141f03;
    border: 0.01rem solid #13141f30;
    margin: 0 auto;
    border-radius: .4rem;
    transition: all 300ms ease-in-out;
    height: 100%;
  }

  .search-input,
  .search-button {
    border: none;
    background: none;
    outline: none;
    padding: 1rem;
    transition: all 300ms ease-in-out;
  }

  .search-button {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
  }

  .search-input {
    width: 100%;
    height: 100%;
    padding-right: 3rem;
  }

  .search-form:focus-within {
    border-color: #269fe6;
  }

  .search-form:focus-within .search-button {
    color: #269fe6;
  }

  .search-button:focus {
    outline: 1px solid #269fe6;
    background-color: rgba(0, 0, 0, .05);
  }

  .pnlMensagensUsuarios {
    flex-direction: column;
    width: 100%;
    overflow-y: auto;
  }

  .pnlMensagemPrincipal {
    width: 100%;
    flex-direction: column;
    display: grid;
    background-color: #EFEAE2;
    grid-template-rows: 60px 1fr 55px;
  }

  .pnlMensagemEnvio {
    padding: 10px 30px;
    height: 55px;
    background-color: rgb(240, 242, 245);
    border-top: .04rem solid #13141f40;
  }

  .pnlUsuarioBuscaSearch {
    position: relative;
    margin: 0 auto;
    height: 100%;
  }

  .send-form {
    background-color: #13141f03;
    background-color: white;
    border: 0.01rem solid #13141f30;
    margin: 0 auto;
    border-radius: .4rem;
    transition: all 300ms ease-in-out;
    height: 100%;
  }

  .send-input,
  .send-button {
    border: none;
    background: none;
    outline: none;
    padding: 1rem;
    transition: all 300ms ease-in-out;
  }

  .send-button {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
  }

  .send-input {
    width: 100%;
    height: 100%;
    padding-right: 3rem;
  }

  .send-form:focus-within {
    border-color: #269fe6;
    background-color: white;
  }

  .send-form:focus-within .send-button {
    color: #269fe6;
  }

  .send-button:focus {
    outline: 1px solid #269fe6;
    background-color: rgba(0, 0, 0, .05);
  }

  .audioHidden {
      width: 0px;
      height: 0px;
  }

</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/chat/Chat.vue